<div mat-dialog-title>
  <h2>
    {{"surveyTasks.fillSurveyForm" | translate}}
  </h2>

  <button mat-icon-button class="close" aria-label="Close" [disabled]="loading" (click)="openConfirmDialog()">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>

<form [formGroup]="formGroup">
  <mat-dialog-content class="p-0">

    <div *ngIf="fetching" class="d-flex justify-content-center align-items-center py-5">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div class="mat-dialog-body p-0" *ngIf="!fetching && items.controls.length">
      <div class="question_container">

        <div class="question_header">
          <div class="question_steps">
            <span class="question_num">
              {{ selectedIndex + 1 }}
            </span>
            {{"general.of" | translate}}
            {{ items.controls.length }}
          </div>
          <mat-progress-bar mode="determinate" [value]="((selectedIndex + 1) / items.controls.length) * 100"
            [color]="'warn'"></mat-progress-bar>
        </div>

        <div class="question_content">
          <mat-horizontal-stepper [linear]="true" #stepper [selectedIndex]="selectedIndex">

            <ng-container *ngFor="let item of items.controls; let i = index" formArrayName="items">
              <mat-step [stepControl]="item" [completed]="item.valid">
                <ng-container [formGroupName]="i">
                  <ng-container *ngTemplateOutlet="questionTpl; context: { $implicit: item }"></ng-container>
                  <ng-container *ngTemplateOutlet="conditionalsTpl; context: { $implicit: item }"></ng-container>


                  <div class="btn_actions">
                    <div>
                      <button mat-raised-button type="button" class="mat-grey-F1" matStepperPrevious
                        (click)="selectedIndex = (selectedIndex - 1)" *ngIf="i">
                        {{"forms.Back" | translate}}
                      </button>
                    </div>

                    <button mat-button type="button" color="primary" matStepperNext
                      *ngIf="i + 1 != items.controls.length" (click)="handelSteps(i)">
                      {{"pagination.Next" | translate}}
                    </button>

                    <button mat-button color="primary" type="button" [class.loading]="loading" [disabled]="loading"
                      (click)="saveRecord()" *ngIf="i + 1 == items.controls.length">
                      {{"surveyTasks.saveAndConfirm" | translate}}
                    </button>
                  </div>

                </ng-container>
              </mat-step>
            </ng-container>

          </mat-horizontal-stepper>
        </div>
      </div>
    </div>

  </mat-dialog-content>
  <ng-template #conditionalsTpl let-item>
    <ng-container *ngFor="let child of getConditionals(item)">
      <ng-container *ngIf="child.enabled">
        <div class="conditional_question">
          <ng-container *ngTemplateOutlet="questionTpl; context: { $implicit: child }"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="conditionalsTpl; context: { $implicit: child }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #questionTpl let-item>
    <ng-container [formGroup]="item">
      <ng-container *ngIf="getQuestionDetails(item) as question">

        <h4 class="question_title">
          {{ question.title }}
        </h4>

        <p class="question_desc" *ngIf="question.isAttachmentsRequired">
          {{"forms.requiresEvidenceAfterAnsweringQuestion" | translate}}
        </p>

        <!-- Text Area -->
        <mat-form-field *ngIf="question.questionTypeCode === questionTypeCodeEnum.Text_Area" class="w-100">
          <mat-label class="primary">{{"general.response" | translate}}</mat-label>
          <textarea matInput formControlName="answer" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"
            maxlength="1000"></textarea>
          <mat-hint align="end">
            {{ item.get('answer')?.value ? (1000 - item.get('answer')?.value.length) : 1000 }}
            / 1000 {{"general.charactersRemaining" | translate}}
          </mat-hint>
          <mat-error *ngIf="hasCtrlError(item, 'answer', 'required')">
            {{"evaluationTasks.questionRequired" | translate}}
          </mat-error>
        </mat-form-field>

        <!-- Single Choice -->
        @if (question.questionTypeCode === questionTypeCodeEnum.Single_Choice) {

        <mat-radio-group formControlName="answer" class="row">
          <div class="col-md-6 col-12 align-items-stretch mb-3" *ngFor="let option of question.options">
            <mat-radio-button class="radio_has_bg h-100" [value]="option.optionId">
              {{ option.text }}
            </mat-radio-button>
          </div>
        </mat-radio-group>
        <mat-error *ngIf="hasCtrlError(item, 'answer', 'required')">
          {{"evaluationTasks.questionRequired" | translate}}
        </mat-error>

        }


        <!-- Multiple Choice -->
        @if(question.questionTypeCode === questionTypeCodeEnum.Multiple_Choice) {
        <div class="row" formArrayName="options">
          <div class="col-md-6 col-12 align-items-stretch mb-3"
            *ngFor="let option of question.options; let optionIndex = index">
            <mat-checkbox class="checkbox_has_bg h-100 w-100" [formControlName]="optionIndex">
              {{ option.text }}
            </mat-checkbox>
          </div>
        </div>

        <mat-error *ngIf="item.hasError('atLeastOneRequired') && item.touched">
          {{"evaluationTasks.atLeastOneOptionSelected" | translate}}
        </mat-error>
        }

        <!-- Star Rating -->
        @if(question.questionTypeCode === questionTypeCodeEnum.Star_Rating) {
        <div class="star_rating text-align-center">
          <mat-icon *ngFor="let star of [1,2,3,4,5]" class="star_icon"
            [class.filled]="star <= (item.get('answer')?.value || 0)" (click)="setStarValue(item, star)">
            {{ star <= (item.get('answer')?.value || 0) ? 'star' : 'star_border' }} </mat-icon>
        </div>
        <mat-error *ngIf="hasCtrlError(item, 'answer', 'required')">
          {{"evaluationTasks.questionRequired" | translate}}
        </mat-error>
        }

        @if (question.questionTypeCode === questionTypeCodeEnum.Single_Choice || question.questionTypeCode
        === questionTypeCodeEnum.Star_Rating) {
        @if (item.get('answer')?.value && !question.isRequired) {
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <button mat-raised-button type="button" (click)="clearResponce(item)" class="mat-grey-F1">
              {{"general.clearResponses" | translate}}
            </button>
          </div>
        </div>
        }
        }

        <!-- Attachments -->
        @if (item.get('answer')?.value || item.get('options')?.value?.includes(true) ||
        (item.get('files')?.value && item.get('files')?.value.length)) {
        <ng-container *ngIf="question.isAttachmentsRequired || question.attachmentUrls.length">
          <h5 class="question_sub_title">
            {{"general.pleaseAttachEvidence" | translate}}
          </h5>
          <app-file-manager class="one-col" [files]="item.get('files')?.value" [maxSize]="5" [maxFiles]="5"
            [isRequired]="hasCtrlError(item, 'files', 'required') || (item.get('files')?.value && item.get('files')?.value.length)"
            [isSubmitted]="hasCtrlError(item, 'files', 'required')" [allowedExt]="['png', 'jpg', 'jpeg','pdf']"
            [managerIndex]="question.id" [invalidFileExtensions]="'evaluationTasks.fileFormatNotSupported'"
            [required]="'evaluationTasks.evidenceRequired'" (selectedFiles)="onFilesSelected(item, $event)"
            (deletedFilesList)="deleteFile( item , $event)"></app-file-manager>
        </ng-container>
        }

      </ng-container>
    </ng-container>
  </ng-template>
</form>
